import { ConditionalRule } from './enums'
import getIterationMethod from './getIterationMethod'
import { Option } from './types'

/**
 * Check if the tag-based condition is satisfied.
 * Such conditions are used to show/hide sections and other entities.
 * @param requestedTags Tags configured as conditional tags by the entity (section, fragment etc.)
 * @param activeTags All tags that are currently activated in the Action Card (conditionalItems)
 * @param rule Logical rule for applying tag-based conditions
 * @returns True if the condition is satisfied, false otherwise
 */
export default function isConditionSatisfied(
  requestedTags: Option[] | null,
  activeTags: number[],
  rule: ConditionalRule | null,
) {
  // If no tags are requested, condition is always satisfied
  if (!requestedTags?.length) return true

  // Check the matching tags based on the logical rule
  const method = getIterationMethod(rule || undefined)
  return method
    ? requestedTags?.[method](t => (activeTags || []).some(id => t.id === id))
    : // None rule means that all tags must satisfy the condition, which in this case is "not being active"
      requestedTags?.every(t => !(activeTags || []).some(id => t.id === id))
}
